export default "__VITE_ASSET__Daeuu9GZ__"